export default {
  "menu": {
    "dashboard": "ダッシュボード (Demo)",
    "orders": "オーダー",
    "api": {
      "title": "API",
      "apiApps": "APIアプリ",
      "callbacks": "コールバック\n",
      "requests": "リクエスト"
    },
    "profile": {
      "title": "プロファイル",
      "updateProfile": "プロファイル変更",
      "updatePassword": "パスワード変更\n"
    },
    "payoutSettings": {
      "title": "出金の設定",
      "withdrawals": "出金",
      "wallets": {
        "title": "ウォレット",
        "bitcoin": "ビットコイン\n",
        "ethereum": "イーサリアム",
        "cardano": "ADA（カルダノ）",
        "ripple": "リップル（XRP）",
        "stellar": "ステラ（XLM）"
      },
      "xpubAddresses": "XPUBアドレス",
      "paymentAddresses": "暗号通貨の受信方法",
      "multisignXpub": "ビットコインのマルチシグネチャ",
      "xlm": "ステラルーメンス（XLM）− アドレス",
      "xrp": "リップル（XRP）− アドレス",
      "ada": "エイダ（ADA） − アドレス",
      "eth": "イーサリアム（ETH）− アドレス",
      "neo": "ネオ（NEO）− アドレス",
      "newAddress": "新アドレス",
      "resendConfirmation": "承認内容再送信",
      "walletName": "ウォレット 名",
      "walletAddress": "ウォレット アドレス",
      "confirmBeforeRemove": "このウォレット アドレスを削除しますか？\n",
      "newWallet": "新しいウォレットの情報を追加しますか？",
      "editWallet": "ウォレットの情報を変更しますか？"
    },
    "apps": "アプリ",
    "users": "ユーザー",
    "system": {
      "title": "システム",
      "adminUsers": "管理ユーザー",
      "cryptoCurrencies": "暗号通貨",
      "systemStatus": "システム状況"
    },
    "directPayment": {
      "title": "直接決済",
      "wallet": "出金ウォレット ",
      "newKey": "公開鍵入力",
      "keyName": "公開鍵名",
      "keyValue": "公開鍵",
      "titleAddXPUB": "BTCの新しい公開鍵を追加する",
      "labelXpub": "XPUBのコード"
    },
    "selectApp": "アプリ選択"
  },
  "headerMenu": {
    "profile": "プロファイル",
    "logout": "ログアウト"
  },
  "updateProfile": {
    "title": "プロファイル変更\n",
    "fullName": "氏名",
    "phoneCountry": "国際電話番号コード",
    "phone": "電話番号",
    "timezone": "時間帯\n",
    "address": "住所"
  },
  "updatePassword": {
    "title": "パスワード変更",
    "currentPassword": "現在のパスワード",
    "newPassword": "新パスワード"
  },
  "button": {
    "edit": "編集する",
    "clear": "クリアする",
    "submit": "送信する",
    "save": "保存する",
    "cancel": "キャンセルする",
    "login": "サインイン",
    "createAnAccount": "アカウント作成する",
    "register": "登録する",
    "goToSignIn": "サインインへ",
    "close": "クローズする",
    "newRequest": "リクエストする",
    "agree": "同意する",
    "disagree": "同意しない"
  },
  "app": {
    "name": "FG Payment"
  },
  "login": {
    "title": "サインイン",
    "forgotPassword": "パスワードを忘れた場合",
    "dontHaveAccount": "新しいお客様ですか？"
  },
  "registration": {
    "title": "登録",
    "haveAccount": "すでにアカウントをお持ちですか?"
  },
  "forgotPassword": {
    "title": "パスワードを回復する",
    "goBackLogin": "ログインへ戻る",
    "sendResetLink": "再設定リンクを送信する"
  },
  "resetPassword": {
    "title": "パスワードを再設定する",
    "resetButton": "パスワードを再設定する"
  },
  "common": {
    "email": "メール",
    "password": "パスワード",
    "passwordConfirmation": "パスワード（確認）",
    "noticeRequiredField": "必須フィールド",
    "status": "ステータス",
    "createdAt": "作成時刻",
    "updatedAt": "更新時刻",
    "successfully": "成功",
    "search": "サーチ"
  },
  "dialog": {
    "order": {
      "titleChangePaid": "オーダーの状態を「払い済み」（PAID）に変更しますか？",
      "confirmUpdate": "このアイテムを更新してもよろしいですか？",
      "checkBalance": "バランス確認",
      "markAsPaid": "「支払済」に変更する",
      "reuseAddress": "アドレスを再利用する"
    },
    "withdrawal": {
      "title": "出金ウォレット を選択する",
      "selectCoin": "暗号通貨",
      "selectWallet": "ウォレット選択",
      "hintDigits": "小数点は{count}桁までです"
    },
    "export": {
      "selectFormat": "フォーマットタイプを選択する"
    },
    "confirmDeleteItem": "このアイテムを削除してもよろしいですか？"
  },
  "table": {
    "order": {
      "merchantOrderID": "販売点注文ID\n",
      "price": "価格",
      "title": "タイトル",
      "payAmount": "支払額",
      "appName": "アプリ名"
    },
    "withdrawal": {
      "receivedWallet": "受信ウォレット",
      "requestAmount": "要求額",
      "receivedAmount": "受領額",
      "fee": "手数料"
    },
    "app": {
      "title": "アプリ名",
      "token": "トークン",
      "deviation": "差分",
      "expiredTime": "有効期限（秒）",
      "newApp": "新アプリの設定",
      "editApp": "アプリ設定を変更する"
    },
    "withdrawnAddress": {
      "owner": "所有者"
    }
  },
  "filter": {
    "byStatus": "ステータスで絞り込み",
    "byApp": "アプリで絞り込み"
  },
  "tooltip": {
    "xpubAddress": "Please get XPUB key with BIP-44 Standard from your wallet. We suggest that you should take this value from cold wallet such as Trezor. As its importance, we suggest that you should do test (make an order and pay with a small amount to make sure that your wallet receive that amount or not) before applying in mass",
    "multisignWallet": "We support Multisignature (multisig) which requires two private keys to sign (authorize) a Bitcoin withdrawal transaction. You need to provide the two XPUB keys in this case. And, as its importance, we suggest that you should do test (make an order and pay with a small amount to make sure that your wallet receive that amount or not) before applying in mass.",
    "xlmPayoutAddress": "To receive XLM, you only need to provide an XLM address. As its importance, we suggest that you should do test (make an order and pay with a small amount to make sure that your wallet receive that amount or not) before applying in mass",
    "xrpPayoutAddress": "To receive XRP, you only need to provide an XRP address. As its importance, we suggest that you should do test (make an order and pay with a small amount to make sure that your wallet receive that amount or not) before applying in mass",
    "refreshData": "データを更新する",
    "filterData": "データをフィルターする",
    "exportData": "データをエクスポートする",
    "closePanel": "パネルをクローズする",
    "remove": "削除する",
    "edit": "編集する",
    "copy": "コピーする"
  }
}
